module.exports = __webpack_public_path__ + "static/media/2.72bc5daa.jpg";